module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO41IngresosMayoresAGastos.060f6ad.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO41IngresosMayoresAGastos.mp4
// module id = 767
// module chunks = 1